/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { Button } from "ui/chakra/components/Button";

import { receiptButtonStyle } from "./styles";

import type { FC } from "react";

type Props = {
  onShowReceipt: () => void;
};

export const ReceiptButton: FC<Props> = (props) => {
  const { onShowReceipt } = props;

  const { t } = useI18n();

  return (
    <Button
      variant="outline"
      colorScheme="primary"
      size="sm"
      onClick={onShowReceipt}
      css={receiptButtonStyle}
    >
      {t("settlementHistory.invoiceGenerate")}
    </Button>
  );
};
